// import { useTheme } from "@mui/material";
import { createContext, ReactNode, useState } from "react";

type TDesignContext = {
  design: "priti" | "judges";
  setDesign: React.Dispatch<React.SetStateAction<"priti" | "judges">>;
};

const initialValue: Omit<TDesignContext, "setDesign"> = {
  design: "priti",
};

export const DesignContext = createContext<TDesignContext>({
  ...initialValue,
  setDesign: () => {},
});
DesignContext.displayName = "DesignContext";

export const DesignProvider = ({ children }: { children: ReactNode }) => {
  const [design, setDesign] = useState<TDesignContext["design"]>("priti");

  return (
    <DesignContext.Provider
      value={{
        design,
        setDesign,
      }}
    >
      {children}
    </DesignContext.Provider>
  );
};
